import { Trans } from 'react-i18next';
import styled from '@emotion/styled';

import { Link, tokens } from '@hotjar/hotsauce';
import { abbrNumber } from '@hotjar/insights-common/lib/number';
import { useIdentifiedUsersCustomEvents } from '@hotjar/webapp/hooks/useIdentifiedUsersCustomEvents';
import { useCurrentSite } from '@hotjar/site';
import { useHelpHotjarUrl } from '@hotjar/translations';

const StyledDiv = styled.div`
  background-color: ${tokens.ALIAS_COLORS.bg_info};
  border: 1px solid ${tokens.color.ui_border};
  border-width: 1px 0 0 0;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
  border-radius: 0;
`;

interface Props {
  trackClick: (elementName: string, shownTrafficCoverage?: number | null) => void;
  coveragePercentage: number;
  isCoverageMeasureComplete: boolean;
}

const HOTJAR_EVENT_UA_DOC_LINK = '/articles/4419626303767';
const NAME = 'UAs_event_counts_link_to_help_center';

export const TrafficCoverageIdentifyUaInfo = ({
  trackClick,
  coveragePercentage,
  isCoverageMeasureComplete,
}: Props): JSX.Element => {
  const { data: currentSite } = useCurrentSite();
  const { data } = useIdentifiedUsersCustomEvents(currentSite);
  const helpHotjarUrl = useHelpHotjarUrl();

  return (
    <StyledDiv>
      <Trans i18nKey="common:sampling-widget.tracking-coverage-message.x-users-and-y-custom-events">
        In the last 24 hours, you identified users in
        {{ sessionAmount: abbrNumber(data?.identifiedSessions ?? 0) }} sessions and tracked
        {{ eventAmount: abbrNumber(data?.customEvents ?? 0) }} custom events with
        <Link
          href={`${helpHotjarUrl}${HOTJAR_EVENT_UA_DOC_LINK}`}
          onClick={() => {
            let elementName;
            if (isCoverageMeasureComplete && coveragePercentage === 100) {
              elementName = 'full_traffic_coverage_edit';
            } else if (isCoverageMeasureComplete) {
              elementName = 'active-traffic-coverage-rate';
            } else {
              elementName = 'measuring_in_progress';
            }
            elementName = `${elementName}_${NAME}`;
            trackClick(elementName, coveragePercentage);
          }}
          kind="inline"
          isExternal
        >
          Hotjar&apos;s APIs
        </Link>
      </Trans>
    </StyledDiv>
  );
};
